var exports = {
  "kL": "AttachmentFile.module__container___RUFmdk",
  "G5": "AttachmentFile.module__deleteButton___RUFmdk",
  "Dq": "AttachmentFile.module__attachmentContainer___RUFmdk",
  "zc": "AttachmentFile.module__iconContainer___RUFmdk",
  "el": "AttachmentFile.module__fileInfoContainer___RUFmdk",
  "Md": "AttachmentFile.module__fileName___RUFmdk",
  "m$": "AttachmentFile.module__fileNameTruncate___RUFmdk",
  "i_": "AttachmentFile.module__fileExtension___RUFmdk",
  "Ov": "AttachmentFile.module__fileSize___RUFmdk",
  "l6": "AttachmentFile.module__downloadButton___RUFmdk",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___RUFmdk",
};

module.exports = exports;
